import { getAuthAxios } from "@artprov/design-system";

const paths = {
  getAll: "tiposSolicitud",
};

export const getTiposSolicitud = async () => {
  const response = await getAuthAxios("default").get(paths.getAll);
  return response;
};